import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getRotables = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/rotables`);
    return response.data;
  } catch (error) {
    console.error('Error fetching rotables:', error.response?.data || error);
    throw error;
  }
};

export const getRotableById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/rotables/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching rotable:', error.response?.data || error);
    throw error;
  }
};

export const createRotable = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/rotables`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating rotable:', error.response?.data || error);
    throw error;
  }
};

export const updateRotable = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/rotables/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating rotable:', error.response?.data || error);
    throw error;
  }
};

export const deleteRotable = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/rotables/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting rotable:', error.response?.data || error);
    throw error;
  }
};

export const getPaginatedRotables = async ({
  page = 1,
  pageSize = 25,
  search = '',
  sortField,
  sortOrder,
  ...filters
}) => {
  const response = await axiosInstance.get(`${API_URL}/rotables/paginated`, {
    params: {
      page,
      pageSize,
      search,
      sortField,
      sortOrder,
      ...filters,
    },
  });
  return response.data;
};

export const sendRotableToSupplier = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/send-to-supplier`, data);
  return response.data;
};

export const receiveRotableFromSupplier = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/receive`, data);
  return response.data;
};

export const fitRotableToAsset = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/fit`, data);
  return response.data;
};

export const removeRotableFromAsset = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/remove`, data);
  return response.data;
};

export const quarantineRotable = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/quarantine`, data);
  return response.data;
};

export const releaseFromQuarantine = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/release`, data);
  return response.data;
};


export const awaitingPickupRotable = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/awaiting-pickup`, data);
  return response.data;
};

export const scrapRotable = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/scrap`, data);
  return response.data;
};

export const sellRotable = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/sell`, data);
  return response.data;
};

export const adjustRotable = async (id, data) => {
  const response = await axiosInstance.post(`${API_URL}/rotables/${id}/adjustment`, data);
  return response.data;
};
